<template>
  <div class="m_container">
    <Header :show-left="showLeft" :title="examInfo.organizer" />
    <section class="m_section">
      <div class="content">
        <p v-html="examInfo.content" />
      </div>
    </section>
    <TabBar :current-tab="currentTab" />
  </div>
</template>

<script>
import Header from '@/components/Header/index'
import TabBar from '@/components/TabBar/index'
import { mapGetters } from 'vuex'

export default {
  name: 'ExamArticleDetail',
  components: { Header, TabBar },
  data() {
    return {
      currentTab: 'homeExam',
      showLeft: true
    }
  },
  computed: {
    ...mapGetters(['examInfo'])
  },
  created() {
  },

  methods: {

  }
}
</script>

<style lang="less" scoped>
.m_container {
  width: 100%;
  min-height: 100vh;
  height: 100%;
  background: #fff;

  .m_section{
    height: 100%;
    min-height: 100vh;
    background: #f5f5f5;
  }

  .content{
    margin:10px;
    padding:10px;
    background: #fff;
    text-align: left;
    word-break: break-word;
    white-space: normal;

    h1{
      padding:0 0 10px 0 ;
      text-align: center;
      font-size: 16px;
      font-weight: 600;
      color:#333;
    }

    p {
      color: #999;
      text-indent: 2em;
      text-align: left;
      line-height: 24px;
      font-size: 13px;
      margin-bottom: 20px;
    }
  }

}
</style>
